import { Component } from '@angular/core';
import {ErrorMessage} from '../../models/error/ErrorMessage';
import {ErrorMessageService} from '../../services/error/error-message.service';
import {BaseErrorDetailRecordComponent} from '../common/base-error-detail-record/base-error-detail-record.component';
import {ErrorDetailRuleComponent} from '../common/error-detail-rule/error-detail-rule.component';
import {
    ErrorDetailTableRecordTemplateComponent
} from '../common/error-detail-table-record-template/error-detail-table-record-template.component';

@Component({
    selector: 'app-error-message-detail-record',
    templateUrl: './error-message-detail-record.component.html',
    styleUrls: ['./error-message-detail-record.component.css'],
    standalone: true,
    imports: [
        ErrorDetailRuleComponent,
        ErrorDetailTableRecordTemplateComponent
    ]
})
export class ErrorMessageDetailRecordComponent extends BaseErrorDetailRecordComponent<ErrorMessage> {
    constructor(private errorMessageService: ErrorMessageService) {
        super(errorMessageService);
    }
}
